import Fab from '@mui/material/Fab';
import { IMapArea } from '../../interfaces';
import { MapContainer, LayersControl, TileLayer, useMap, useMapEvents } from "react-leaflet";
import Grid from '@mui/material/Grid';
import { useEffect, useState, useRef } from 'react';
import { SchadflaechenLayer } from './Layer/SchadflaechenLayer';
import { SchadflaechenSelectedLayer } from './Layer/SchadflaechenSelectedLayer';
import config from "../../config.json";
import ShareIcon from '@mui/icons-material/Share';
import LeafletControlGeocoder from './Geocoder';
import { Box, duration, styled } from '@mui/material';
import { ScaleControl } from 'react-leaflet'
// import VectorGrid from 'react-leaflet-vectorgrid';
import useTheme from '@mui/material/styles/useTheme';
import LegendSimple from './LegendSimple.component';
import Button from '@mui/material/Button';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TimelineIcon from '@mui/icons-material/Timeline';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { keyframes } from '@mui/system';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import { GeoJSON } from 'react-leaflet'
import L from "leaflet"
import MarkerClusterGroup from 'react-leaflet-markercluster';

import { backendService } from '../../Services/backend.service';

import jsonData from "./test.json"
import FireIcon from '@mui/icons-material/Whatshot';
// import FireIcon from '@mui/icons-material/LocalFireDepartment';
// import structuredClone from '@ungap/structured-clone';
import _ from "lodash"




export default function MapArea(props) {
    const [inIframe, setInIframe] = useState(false);
    var layersWaldzustandLabels = [];
    config["layersWaldzustand"].forEach((layer) => layersWaldzustandLabels.push(layer.label));
    const darkMapUrl = 'https://tile.jawg.io/jawg-dark/{z}/{x}/{y}{r}.png?access-token='.concat(config["general"].jawgApiKey)
    const leftOffset = 15;

    useEffect(() => {
        if (window.location !== window.parent.location) {
            // The page is in an iframe
            setInIframe(true);
        }
    }, [])

    const mapButtonClicked = (subdrawerType) => {
        switch (subdrawerType) {
            case "LAYER":
                props.setActiveLayer(config["layersWaldzustand"][props.tabIndexWaldzustand].label)
                break;
            case "BAUMARTEN":
                props.setActiveLayer(config["layersBaumarten"][0].label)
                break;
            case "FIRE":
                props.setActiveLayer("fire")
                break;
            case "SCHADEN":
                props.setActiveLayer(config["layersSchaden"][0].label)
                break;
            // case "TEILEN":
            //     props.setLeftSubDrawerOpen(true)
            //     break;

        }
        props.setLeftSubDrawerType(subdrawerType)
    }

    const fullScreen = () => {
        window.open("https://map3d.remote-sensing-solutions.de/waldmonitor-deutschland");

    }


    return (
        <Box
            position="fixed"
            sx={{ width: "100%" }}
        >
            <>
                {props.mobile &&
                    <Buttons
                        fullScreen={fullScreen}
                        mapButtonClicked={mapButtonClicked}
                        leftOffset={leftOffset}
                        {...props}
                    />
                }
                <LegendSimple
                    activeLayer={props.activeLayer}
                    mobile={props.mobile}
                    setLeftSubDrawerOpen={props.setLeftSubDrawerOpen}
                    setLeftSubDrawerType={props.setLeftSubDrawerType}
                    leftSubDrawerOpen={props.leftSubDrawerOpen}
                />
                <Grid item className="map-container" xs={12} >
                    <MapContainer
                        className="map-container"
                        scrollWheelZoom={true}
                        zoomControl={false}
                        maxZoom={13}
                        minZoom={6}
                        maxBounds={[[42.3024876979, -5.98865807458], [59.983104153, 25.0169958839]]}
                        bounds={[[49.3956634, 7.0300363], [53.053473, 10.3863514]]}>
                        <ScaleControl position="bottomright" />
                        <LeafletControlGeocoder />
                        {console.log(props.activeLayer)}
                        {/* Fire */}
                        {props.activeLayer === "fire" &&
                            <FireMarker {...props}></FireMarker>
                        }

                        {/* Baumarten */}
                        {props.activeLayer === config["layersBaumarten"][0].label &&
                            <TileLayer
                                key={config["layersBaumarten"][0].label}
                                url={config["layersBaumarten"][0].url}
                                zIndex={10}
                            />
                        }

                        {/* Waldzustand */}
                        {console.log("active layer", props.activeLayer)}
                        {layersWaldzustandLabels.includes(props.activeLayer) &&
                            <WaldzustandsTileLayer activeLayer={props.activeLayer} version={props.version}></WaldzustandsTileLayer>
                        }
                        {/* SChaden */}
                        {props.activeLayer === config["layersSchaden"][0].label &&
                            <TileLayer
                                key={config["layersSchaden"][0].label}
                                url={config["layersSchaden"][0].url}
                                zIndex={10}
                            />
                        }

                        {/* Bundesland Statistik */}
                        <>
                            <SchadflaechenSelectedLayer
                                setSelectedAreaId={props.setSelectedAreaId}
                                selectedAreaId={props.selectedAreaId}
                                setBundesland={props.setBundesland}
                            ></SchadflaechenSelectedLayer>
                            <SchadflaechenLayer
                                setSelectedAreaId={props.setSelectedAreaId}
                                selectedAreaId={props.selectedAreaId}
                            ></SchadflaechenLayer>
                            <MapInteraction mapBounds={props.mapBounds} />
                        </>

                        {/* Basemaps */}
                        <LayersControl position="topright">
                            <LayersControl.BaseLayer checked name="Satellit">
                                <TileLayer
                                    // zIndex={1}
                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                                />
                            </LayersControl.BaseLayer>
                            <LayersControl.BaseLayer name="Dunkel" >
                                <TileLayer
                                    url={darkMapUrl}
                                    attribution='<a href=\"https://www.jawg.io\" target=\"_blank\">&copy; Jawg</a> - <a href=\"https://www.openstreetmap.org\" target=\"_blank\">&copy; OpenStreetMap</a>&nbsp;contributors'
                                />
                            </LayersControl.BaseLayer>
                            <LayersControl.BaseLayer name="Karte">
                                <TileLayer
                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                            </LayersControl.BaseLayer>
                        </LayersControl>
                    </MapContainer>
                </Grid>
            </>
        </Box>
    );


}


function getFireMarker(color, latlng) {
    return (L.marker(latlng, {
        icon: L.divIcon({
            html: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="${color}"><path d="M0 0h24v24H0z" fill="none"/><path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"/></svg>`,
            className: "",
            iconAnchor: [12, 12],
        })
    })
    )
}



function FireMarker(props) {
    const map = useMap()
    const [jsonDataFire, setJsonDataFire] = useState(null)
    // const [latestDate, setLatestDate] = useState(null)
    const [apiCallsFinished, setApiCallsFinished] = useState(false)

    const COLORS_MARKER = [
        "#ec1a18",
        "#f05a1a",
        "#f38c1c",
        "#f6c61e",
        "#F7EC1E",
        "#EAE84F",
        "#D9D583",
        "#C8C1BD"
    ]

    useEffect(() => {
        // Gets current date and fire geojson
        backendService.getFires()
            .then((fires) => { setJsonDataFire(fires) })
            .catch((e) => console.log(e))

    }, [])


    useEffect(() => {
        if (!map) return;
        // Adds markers to map

        // Create markers
        const markers = new L.GeoJSON(jsonDataFire, {
            pointToLayer: (feature, latlng) => {
                // const dateDiff = (new Date(latestDate["last_fire"]) - new Date(feature.properties.ACQ_DATE)) / (1000 * 60 * 60 * 24)

                const dateDiff = (new Date() - new Date(feature.properties.ACQ_DATE)) / (1000 * 60 * 60 * 24)
                const dateDiffFloored = dateDiff | 0;


                switch (dateDiffFloored) {
                    case 0:
                        return getFireMarker(COLORS_MARKER[0], latlng)
                    case 1:
                        return getFireMarker(COLORS_MARKER[1], latlng)
                    case 2:
                        return getFireMarker(COLORS_MARKER[2], latlng)
                    case 3:
                        return getFireMarker(COLORS_MARKER[3], latlng)
                    case 4:
                        return getFireMarker(COLORS_MARKER[4], latlng)
                    case 5:
                        return getFireMarker(COLORS_MARKER[5], latlng)
                    case 6:
                        return getFireMarker(COLORS_MARKER[6], latlng)
                    case 7:
                        return getFireMarker(COLORS_MARKER[7], latlng)
                    case 8:
                        return getFireMarker(COLORS_MARKER[8], latlng)
                }
            },
            // onEachFeature: (feature = {}, layer) => {}
        });
        const markersCluster = new L.MarkerClusterGroup({
            disableClusteringAtZoom: 2,
            // singleMarkerMode: true,
            // iconCreateFunction: function (cluster) {
            //     return L.divIcon({ html: '<b>Test ' + cluster.getChildCount() + '</b>' });
            // }
            iconCreateFunction: function (cluster) {
                var markers = cluster.getAllChildMarkers();
                var html = '<div class="circle">' + markers.length + '</div>';
                return L.divIcon({ html: html, className: 'mycluster', iconSize: L.point(32, 32) });
            },
            showCoverageOnHover: true, zoomToBoundsOnClick: true
        });
        let markersDeepCopy = _.cloneDeep(markers)
        markersCluster.addLayer(markersDeepCopy);

        // Switch between clusters and single markers deepending on zoom
        // Necessary to show clusters of 1 (https://github.com/Leaflet/Leaflet.markercluster/issues/391)
        function onZoom() {
            if (map.getZoom() < 11) {
                // Layer A needs to be removed before Layer B can be added. Otherwise it is not shown!
                if (map.hasLayer(markers)) {
                    map.removeLayer(markers)
                }
                if (!map.hasLayer(markersCluster)) {
                    map.addLayer(markersCluster)
                }
            } else {
                if (map.hasLayer(markersCluster)) {
                    map.removeLayer(markersCluster)
                }
                if (!map.hasLayer(markers)) {
                    console.log("adding single markers")
                    console.log(markers)
                    map.addLayer(markers)
                }

            }
        }

        map.addLayer(markersCluster)
        map.on('zoom', onZoom);

        return () => {
            // Cleanup function
            map.removeLayer(markersCluster)
            map.removeLayer(markers)
            // map.removeLayer(markersDeepCopy)
            // map.off('zoom', onZoom);
        }
    }, [jsonDataFire])

    return null;
}



function Buttons(props) {
    const blink = keyframes`
    from { opacity: 0.3; }
     to { opacity: 1; }
    `;
    const bottomOffsetMobile = 306;
    const bottomOffsetDesktop = 150;
    const buttonSpaceBetween = 56 + 15;
    return (<>
        <Box>

            {props.inIframe &&
                <Button
                    color="primary"
                    aria-label="treeType"
                    variant="contained"
                    onClick={() => props.fullScreen()}
                    sx={{
                        position: 'absolute',
                        right: props.leftOffset,
                        zIndex: 2000,
                        ...(props.mobile ? { bottom: bottomOffsetMobile + buttonSpaceBetween * 2 } : { bottom: bottomOffsetDesktop + buttonSpaceBetween * 2 }),
                    }}>
                    <FullscreenIcon />
                </Button>}


            <Button
                aria-label="burn"
                variant="contained"
                onClick={() => props.mapButtonClicked("FIRE")}
                disabled={props.leftSubDrawerType === "FIRE"}
                sx={{
                    position: 'absolute',
                    ...(props.mobile ? { bottom: bottomOffsetMobile + 2 * buttonSpaceBetween } : { bottom: bottomOffsetDesktop + 2 * buttonSpaceBetween }),
                    right: props.leftOffset,
                    zIndex: 2000,

                    border: 0,
                    // borderRadius: 3,
                    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
                    color: 'white',

                }}>
                <FireIcon sx={{ color: 'red', animation: `${blink} 1.5s linear infinite` }} />
            </Button>
            <Button
                color="primary"
                aria-label="treeType"
                variant="contained"
                onClick={() => props.mapButtonClicked("BAUMARTEN")}
                disabled={props.leftSubDrawerType === "BAUMARTEN"}
                sx={{
                    position: 'absolute',
                    ...(props.mobile ? { bottom: bottomOffsetMobile + buttonSpaceBetween } : { bottom: bottomOffsetDesktop + buttonSpaceBetween }),
                    right: props.leftOffset,
                    zIndex: 2000,
                }}>
                <DonutLargeIcon />
            </Button>

            <Button
                color="primary"
                aria-label="schadflaechen"
                variant="contained"
                onClick={() => props.mapButtonClicked("LAYER")}
                disabled={props.leftSubDrawerType === "LAYER"}
                sx={{
                    position: 'absolute',
                    ...(props.mobile ? { bottom: bottomOffsetMobile } : { bottom: bottomOffsetDesktop }),
                    right: props.leftOffset,
                    zIndex: 2000,
                }}
            >
                <TimelineIcon />
            </Button>
        </Box>
    </>);
}


function MapInteraction(props) {
    const map = useMap()
    useDidMountEffect(() => {
        map.flyToBounds(props.mapBounds, {
            animate: true,
            duration: 2
        })
    }, [props.mapBounds])

    return null
}

const useDidMountEffect = (func, deps) => {
    // Prevents re-render on inital load
    const didMount = useRef(false);
    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
}


function WaldzustandsTileLayer(props) {
    console.log(props.version)
    let tileLayer = null;
    config["layersWaldzustand"].filter(layer => {
        // console.log("Layer", layer)

        if (layer.label === props.activeLayer) {
            if (layer.period === props.version) {
                tileLayer = (
                    <TileLayer
                        key={layer.label + props.version}
                        url={layer.url}
                        zIndex={9}
                    />
                )

                // switch (props.version) {
                //     case "2016_2020":
                //         console.log("switch", props.version)
                //         tileLayer = (
                //             <TileLayer
                //                 key={layer.label + props.version}
                //                 url={layer.url}
                //                 zIndex={9}
                //             />
                //         )
                //         break;
                //     case "2020_2021":
                //         console.log("switch", props.version)
                //         // console.log("2020_2021")
                //         tileLayer = (
                //             <TileLayer
                //                 key={layer.label + props.version}
                //                 url={layer.url}
                //                 zIndex={9}
                //             />
                //         )
                //         break;
                //     case "2021_2022":
                //         console.log("switch", props.version)
                //         tileLayer = (
                //             <TileLayer
                //                 key={layer.label + props.version}
                //                 url={layer.url}
                //                 zIndex={9}
                //             />
                //         )
                //         break;


            }
        }
    })
    return tileLayer
}


function SchadenTileLayer(props) {
    console.log(props.version)
    let tileLayer = null;
    config["layersSchaden"].filter(layer => {
        // console.log("Layer", layer)

        if (layer.label === props.activeLayer) {
            tileLayer = (
                <TileLayer
                    key={layer.label}
                    url={layer.url}
                    zIndex={9}
                />
            )

        }
    })
    return tileLayer
}

